export default __webpack_public_path__ + "static/feature-widget-4bae55b2d00fd0dad9b8fa6a5955fe4c.png";